import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import {setCookie, 
    getCookie
} from '../helpers/cookie-scripts';

export default () => {
    gsap.registerPlugin(ScrollTrigger);
    document.body.style.overflow = 'hidden';
    // document.querySelector('.header').style.opacity = 0;
    
    const wrapper = document.querySelector('[data-preload-wrapper]');
    const bottom = wrapper.querySelector('[data-preload-bottom]');
    const text = wrapper.querySelector('[data-preload-text]');
    const contentHero = document.querySelector('[data-video-picture]');
    const contentVideo = document.querySelector('[data-video-wrapper]');
    const videoRight = document.querySelector('.video-right');
    const videoSection = document.querySelector('.video-section')
    function isTablet(){
        return window.innerWidth < 1024 && window.innerWidth > 639
    }
    function isMobile(){
        return window.innerWidth < 640
    }
    if ((wrapper.dataset.closed == 'true') && (getCookie('closed-collection') != 'true')) {
        wrapper.style.display = 'none'; 
        return false
    }
    else {
        wrapper.style.display = 'block';
    }

    
    gsap.set(contentHero, {
        y: '100vh'
    })
    gsap.set(videoSection, {
        height: 'calc(100vh - 76px)'
    })
    gsap.set('[data-video-button]', {
        opacity: 0,
    })

    // Text to the top
    gsap.to(text, {
        top: '0%',
        y: '-100px',
        delay: 1,
        duration: 2,
        ease: 'Power1.easeOut',
        onStart: () =>{
            // fadeout text
            gsap.to(text, {
                opacity: 0,
                delay: 0,
                duration: 1,
                ease: 'Power2.easeIn',
            })
            // move bottom box to the top
            gsap.to(bottom, {
                y: 0,
                delay: 0.2,
                duration: 1,
                onComplete: ()=>{
                    //move bottom box outside the screen
                    gsap.to(wrapper, {
                        y: '-100%',
                        delay: 0,
                        duration: 1,
                        onStart: () =>{
                            //stretch out video 
                            gsap.to(videoRight, {
                                width: 0,
                                duration: 2,
                                onComplete: ()=>{
                                    
                                    //remove elements over the video
                                    gsap.to('.video-before', {
                                        height: 0,
                                        duration: 0.5
                                    })
                                    gsap.to('.video-after', {
                                        height: 0,
                                        duration: 0.5,
                                        onComplete: ()=>{
                                            //lifting up hero content and setting up final layout
                                            gsap.to(contentHero, {
                                                y: 0,
                                                duration: 1
                                            })
                                            gsap.to(contentVideo, {
                                                width: isTablet() || isMobile()?'87%':'46%',
                                                top:  isTablet() || isMobile()?300:50,
                                                left: isTablet() || isMobile()?0:'54%',
                                                duration: 1,
                                                onComplete: () =>{
                                                    contentVideo.classList.add('finish')
                                                }
                                            })
                                            gsap.to('.video-section__video', {
                                                height: isMobile()?267:560,
                                                duration: 1,
                                                borderRadius: 5,
                                                onComplete: ()=>{
                                                    if (isTablet() || isMobile()){

                                                    document.querySelector('.home-shop').style.marginTop = contentVideo.scrollHeight + 'px';
                                                }
                                                    document.querySelector('.home-shop').style.opacity = 1;
                                                
                                                    
                                                    //revealing buttons
                                                    gsap.to('[data-video-button]', {
                                                        opacity: 1,
                                                        duration:1,
                                                        ease: 'Power1.easeIn'
                                                    })
                                                    document.body.style.overflow = 'auto';
                                                }
                                            })
                                            gsap.to(videoSection, {
                                                
                                                height: isTablet() || isMobile()?'auto':675,
                                                onComplete : () =>{
                                                    ScrollTrigger.refresh(true);
                                                }
                                               
                                            })
                                        }
                                    })
                                }
                            })
                            //showing header and add overflow 
                            gsap.to('.header', {
                                opacity: 1,
                                duration: 0.5,
                                delay: 0.5,
                                ease: 'Power1.easeIn',
                                onStart: () =>{
                                    wrapper.style.zIndex = '-1';
                                }
                            })
                        },
                    })
                }
            })
        }
        
    })


    
}
